import { memo, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import { ReactComponent as CheckMarkIcon } from 'images/Icons/CheckMark.svg';

import styles from './Filters.module.scss';

const Filters = ({ name, value, items, onChange, completed }) => {
  const itemsJSX = useMemo(
    () =>
      items.map(({ label, value: itemValue }) => {
        const isCompleted = completed?.includes(itemValue);
        const isActive = value === itemValue;

        return (
          <div
            key={itemValue}
            onClick={() => onChange(name, itemValue)}
            className={classNames(styles.item, {
              [styles.completed]: isCompleted,
              [styles.active]: isActive,
            })}
          >
            <Typography type="text-sm" weight="medium" color="inherit">
              {label}
            </Typography>
            {isCompleted && (
              <CheckMarkIcon
                className={classNames(styles.checkMarkIcon, {
                  [styles.active]: isActive,
                })}
              />
            )}
          </div>
        );
      }),
    [items, completed, onChange, name, value],
  );

  return <div className={styles.root}>{itemsJSX}</div>;
};

Filters.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  completed: PropTypes.arrayOf(PropTypes.string),
};

export default memo(Filters);
